/* NORDVANCE — zachowanie bloków karty produktu: zestawy 1/2/3, termin dostawy, mini-opinie.
   Bez zależności. Odporne na ponowne renderowanie sekcji (zmiana wariantu, edytor motywu). */
(function () {
  if (window.__nvp) return;
  window.__nvp = 1;

  var LOCALE = 'pl-PL';
  function money(cents, cur) {
    try { return (cents / 100).toLocaleString(LOCALE, { style: 'currency', currency: cur || 'PLN' }); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' zł'; }
  }

  /* ---------- ZESTAWY ---------- */
  var chosen = {}; // klucz: id bloku -> wybrana ilość

  function scopeOf(el) { return el.closest('.shopify-section') || document; }
  function qtyInput(scope) { return scope.querySelector('product-form-component input[name="quantity"], form[action*="/cart/add"] input[name="quantity"]'); }
  function idInput(scope) { return scope.querySelector('product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]'); }

  function setQty(scope, q) {
    var inp = qtyInput(scope);
    if (!inp) return;
    if (String(inp.value) === String(q)) return;
    var max = inp.getAttribute('max');
    if (max && Number(max) > 0 && q > Number(max)) q = Number(max);
    inp.value = q;
    inp.setAttribute('value', q);
    inp.dispatchEvent(new Event('input', { bubbles: true }));
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function priceFor(box, vid) {
    var map = box.__prices;
    if (!map) { try { map = box.__prices = JSON.parse(box.getAttribute('data-prices') || '{}'); } catch (e) { map = box.__prices = {}; } }
    return map[String(vid)];
  }

  function renderTiers(box) {
    var scope = scopeOf(box);
    var idEl = idInput(scope);
    var vid = idEl && idEl.value ? idEl.value : box.getAttribute('data-default-variant');
    var unit = priceFor(box, vid);
    if (unit == null) unit = Number(box.getAttribute('data-default-price')) || 0;
    var cur = box.getAttribute('data-currency');
    box.querySelectorAll('.nvp-tier').forEach(function (t) {
      var q = Number(t.getAttribute('data-qty')) || 1;
      var pct = Number(t.getAttribute('data-pct')) || 0;
      var full = unit * q;
      var off = Number(t.getAttribute('data-off')) || 0;
      var total = off > 0 ? Math.max(0, full - off) : Math.round(full * (100 - pct) / 100);
      var p = t.querySelector('[data-total]'); if (p) p.textContent = money(total, cur);
      var c = t.querySelector('[data-full]'); if (c) { c.textContent = total < full ? money(full, cur) : ''; c.hidden = !(total < full); }
      var u = t.querySelector('[data-unit]'); if (u) { u.textContent = q > 1 ? money(Math.round(total / q), cur) + ' / szt.' : ''; u.hidden = q <= 1; }
      var s = t.querySelector('[data-save]'); if (s) { var sv = full - total; s.textContent = sv > 0 ? 'Oszczędzasz ' + money(sv, cur) : ''; s.hidden = !(sv > 0); }
    });
  }

  /* ---------- ZESTAW W RÓŻNYCH KOLORACH (AG2 19.10) ----------
     Sztuka 1 = kolor wybrany w zwykłym wyborze wariantu. Sztuki 2..n mają własne kółka.
     Do koszyka: główny wariant z ilością (1 + sztuki w tym samym kolorze) + pozostałe kolory jako items[]. */
  function colorsOf(box) {
    if (box.__colors !== undefined) return box.__colors;
    var el = box.querySelector('[data-nvp-colors]');
    try { box.__colors = el ? JSON.parse(el.textContent) : null; } catch (e) { box.__colors = null; }
    return box.__colors;
  }
  function tierQty(box) {
    var t = box.querySelector('.nvp-tier[aria-checked="true"]');
    return t ? (Number(t.getAttribute('data-qty')) || 1) : 1;
  }
  function mixOn(box) { var c = colorsOf(box); return !!(c && c.length > 1 && tierQty(box) > 1); }
  function mainId(box) { var i = idInput(scopeOf(box)); return i && i.value ? String(i.value) : String(box.getAttribute('data-default-variant')); }
  function mixPieces(box) {
    var n = tierQty(box) - 1, m = box.__mix || (box.__mix = []);
    while (m.length < n) m.push(mainId(box));
    return m.slice(0, n);
  }
  function mainQty(box) {
    if (!mixOn(box)) return chosen[box.getAttribute('data-block')];
    var main = mainId(box);
    return 1 + mixPieces(box).filter(function (v) { return String(v) === main; }).length;
  }
  function pickMain(name) {
    var inp = Array.prototype.slice.call(document.querySelectorAll('variant-picker input[type="radio"]')).filter(function (x) { return x.value === name; })[0];
    if (inp && !inp.checked) inp.click();
  }
  function renderMix(box) {
    var c = colorsOf(box); if (!c) return;
    var wrap = box.querySelector('.nvp-mix');
    if (!mixOn(box)) { if (wrap) wrap.remove(); return; }
    if (!wrap) { wrap = document.createElement('div'); wrap.className = 'nvp-mix'; var list = box.querySelector('.nvp-bundles__list'); list.parentNode.insertBefore(wrap, list.nextSibling); }
    var main = mainId(box), pieces = mixPieces(box);
    function nameOf(id) { var x = c.filter(function (k) { return String(k.id) === String(id); })[0]; return x ? x.n : ''; }
    function dots(cur, idx) {
      return c.map(function (k) {
        return '<button type="button" class="nvp-mix__dot" data-i="' + idx + '" data-v="' + k.id + '" title="' + k.n + '" aria-label="' + k.n + '" aria-pressed="' + (String(k.id) === String(cur)) + '" style="background:' + k.h + '"' + (k.a ? '' : ' disabled') + '></button>';
      }).join('');
    }
    var html = '<p class="nvp-mix__h">Wybierz kolor każdej sztuki</p>';
    html += '<div class="nvp-mix__row"><span class="nvp-mix__lbl">1. sztuka: <b>' + nameOf(main) + '</b></span><span class="nvp-mix__dots">' + dots(main, 0) + '</span></div>';
    pieces.forEach(function (v, i) {
      html += '<div class="nvp-mix__row"><span class="nvp-mix__lbl">' + (i + 2) + '. sztuka: <b>' + nameOf(v) + '</b></span><span class="nvp-mix__dots">' + dots(v, i + 1) + '</span></div>';
    });
    if (wrap.__html !== html) { wrap.innerHTML = html; wrap.__html = html; }
    if (!wrap.__bound) {
      wrap.__bound = true;
      wrap.addEventListener('click', function (e) {
        var d = e.target.closest('.nvp-mix__dot'); if (!d || d.disabled) return;
        var i = Number(d.getAttribute('data-i')), v = d.getAttribute('data-v');
        if (i === 0) { var k = c.filter(function (x) { return String(x.id) === v; })[0]; if (k) pickMain(k.n); }
        else { box.__mix[i - 1] = v; }
        setTimeout(function () { renderMix(box); setQty(scopeOf(box), mainQty(box)); syncItems(scopeOf(box)); }, 60);
      });
    }
  }
  /* galeria: kliknięcie zdjęcia koloru wybiera ten kolor */
  document.addEventListener('click', function (e) {
    var img = e.target.closest && e.target.closest('media-gallery img, slideshow-slide img, .product-media img, .product-media-container img');
    if (!img) return;
    var src = (img.currentSrc || img.src || '').split('?')[0].split('/').pop();
    document.querySelectorAll('.nvp-bundles').forEach(function (box) {
      var c = colorsOf(box); if (!c) return;
      var k = c.filter(function (x) { return x.f && src.indexOf(x.f.replace(/\.[a-z]+$/i, '')) === 0; })[0];
      if (k) pickMain(k.n);
    });
  });

  function select(box, tier, fromUser) {
    box.querySelectorAll('.nvp-tier').forEach(function (t) {
      var on = t === tier;
      t.setAttribute('aria-checked', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    var q = Number(tier.getAttribute('data-qty')) || 1;
    chosen[box.getAttribute('data-block')] = q;
    renderMix(box);
    setQty(scopeOf(box), mixOn(box) ? mainQty(box) : q);
    syncItems(scopeOf(box));
    if (fromUser) tier.focus({ preventScroll: true });
  }

  function initBundles(box) {
    if (box.__nvpInit) return;
    box.__nvpInit = true;
    var scope = scopeOf(box);
    if (box.hasAttribute('data-hide-qty')) scope.classList.add('nvp-hide-qty');
    var tiers = Array.prototype.slice.call(box.querySelectorAll('.nvp-tier'));
    if (!tiers.length) return;
    var key = box.getAttribute('data-block');
    var want = chosen[key];
    var start = tiers.filter(function (t) { return want ? Number(t.getAttribute('data-qty')) === want : t.getAttribute('aria-checked') === 'true'; })[0] || tiers[0];
    tiers.forEach(function (t, i) {
      t.addEventListener('click', function () { select(box, t, true); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowDown' || k === 'ArrowRight') n = tiers[(i + 1) % tiers.length];
        if (k === 'ArrowUp' || k === 'ArrowLeft') n = tiers[(i - 1 + tiers.length) % tiers.length];
        if (n) { e.preventDefault(); select(box, n, true); }
      });
    });
    renderTiers(box);
    select(box, start, false);
  }

  /* ---------- GRATIS + DODATKI: dopisujemy pozycje items[] do formularza koszyka ----------
     Shopify /cart/add dodaje produkt z id + quantity ORAZ wszystkie pozycje items[] (sprawdzone 12.10). */
  function formOf(scope) { return scope.querySelector('product-form-component form, form[action*="/cart/add"]'); }
  function syncItems(scope) {
    var form = formOf(scope);
    if (!form) return;
    var extras = [];
    var tier = scope.querySelector('.nvp-bundles .nvp-tier[aria-checked="true"][data-gift]');
    if (tier) extras.push(tier.getAttribute('data-gift'));
    // dodatek cyfrowy trafia do koszyka tylko ze zgodą (art. 38 pkt 13 upk); zgoda = właściwość pozycji „Zgoda”
    var props = {};
    scope.querySelectorAll('.nvp-addon__cb:checked').forEach(function (cb) {
      var v = cb.getAttribute('data-variant'), c = consentOf(cb);
      if (c && !c.checked) return;
      extras.push(v); if (c) props[v] = c.getAttribute('data-text');
    });
    syncMainConsent(scope, form);
    var idEl = idInput(scope), qEl = qtyInput(scope);
    var main = idEl ? idEl.value : '', q = qEl ? (Number(qEl.value) || 1) : 1;
    // zestaw w różnych kolorach: sztuki w innym kolorze niż główny idą jako items[]
    var mixBox = scope.querySelector('.nvp-bundles');
    if (mixBox && mixOn(mixBox)) { mixPieces(mixBox).forEach(function (v) { if (String(v) !== String(main)) extras.push(String(v)); }); }
    var sig = extras.length ? main + 'x' + q + '|' + extras.join(',') : '';
    if (form.__nvpSig === sig) return;
    form.__nvpSig = sig;
    form.querySelectorAll('input[data-nvp-item]').forEach(function (x) { x.remove(); });
    if (!extras.length || !main) return;
    function add(name, val) { var i = document.createElement('input'); i.type = 'hidden'; i.name = name; i.value = val; i.setAttribute('data-nvp-item', ''); form.appendChild(i); }
    // Produkt główny dodaje Shopify z pól id + quantity; items[] zawiera tylko gratis i dodatki.
    extras.forEach(function (v, k) {
      add('items[' + k + '][id]', v); add('items[' + k + '][quantity]', 1);
      if (props[v]) add('items[' + k + '][properties][Zgoda]', props[v]);
    });
  }
  function consentOf(cb) { var row = cb.closest('.nvp-addon-row'); return row ? row.querySelector('.nvp-consent__cb') : null; }
  /* zgoda na stronie samego produktu cyfrowego: pole properties[Zgoda] w formularzu tylko po zaznaczeniu */
  function syncMainConsent(scope, form) {
    var c = scope.querySelector('[data-nvp-consent-main] .nvp-consent__cb');
    var old = form.querySelector('input[data-nvp-consent-prop]');
    if (c && c.checked) {
      if (!old) { old = document.createElement('input'); old.type = 'hidden'; old.name = 'properties[Zgoda]'; old.setAttribute('data-nvp-consent-prop', ''); form.appendChild(old); }
      old.value = c.getAttribute('data-text');
    } else if (old) { old.remove(); }
  }
  function clearErr(box) { if (!box) return; box.classList.remove('is-err'); var er = box.querySelector('.nvp-consent__err'); if (er) er.hidden = true; }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.classList) return;
    if (t.classList.contains('nvp-addon__cb')) { if (!t.checked) clearErr(t.closest('.nvp-addon-row') && t.closest('.nvp-addon-row').querySelector('[data-nvp-consent]')); syncItems(scopeOf(t)); }
    if (t.classList.contains('nvp-consent__cb')) {
      if (t.checked) clearErr(t.closest('[data-nvp-consent]'));
      var sc = scopeOf(t), f = formOf(sc);
      if (f) { f.__nvpSig = null; syncItems(sc); syncMainConsent(sc, f); }
    }
  });
  /* blokada zakupu bez zgody: na window w fazie capture, czyli przed obsługą motywu (Horizon deleguje on:submit/on:click wyżej niż element) */
  function guard(e) {
    var t = e.target, form = null;
    if (e.type === 'submit') form = t;
    else if (t && t.closest) { var b = t.closest('button[name="add"], button[type="submit"]'); form = b ? (b.form || b.closest('form')) : null; }
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var scope = scopeOf(form), bad = [];
    scope.querySelectorAll('.nvp-addon__cb:checked').forEach(function (cb) { var c = consentOf(cb); if (c && !c.checked) bad.push(c.closest('[data-nvp-consent]')); });
    var mc = scope.querySelector('[data-nvp-consent-main] .nvp-consent__cb');
    if (mc && !mc.checked) bad.push(mc.closest('[data-nvp-consent]'));
    if (!bad.length) { form.__nvpSig = null; syncItems(scope); return; }
    e.preventDefault(); e.stopImmediatePropagation();
    bad.forEach(function (b) { b.classList.add('is-err'); var er = b.querySelector('.nvp-consent__err'); if (er) er.hidden = false; });
    bad[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  window.addEventListener('click', guard, true);
  window.addEventListener('submit', guard, true);

  /* zmiana wariantu: lekki nasłuch wartości ukrytego pola id */
  var lastIds = new WeakMap();
  function watchVariants() {
    document.querySelectorAll('.nvp-bundles').forEach(function (box) {
      var scope = scopeOf(box);
      var idEl = idInput(scope);
      var v = idEl ? idEl.value : '';
      if (lastIds.get(box) !== v) { lastIds.set(box, v); renderTiers(box); renderMix(box); }
      var want = mixOn(box) ? mainQty(box) : chosen[box.getAttribute('data-block')];
      var qi = qtyInput(scope);
      if (want && qi && String(qi.value) !== String(want)) setQty(scope, want);
    });
    var seen = [];
    document.querySelectorAll('.nvp-bundles, .nvp-addons').forEach(function (el) {
      var sc = scopeOf(el);
      if (seen.indexOf(sc) === -1) { seen.push(sc); syncItems(sc); }
    });
  }

  /* ---------- DOSTAWA ---------- */
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
      h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, mo - 1, da);
  }
  var holidayCache = {};
  function isHoliday(dt) {
    var y = dt.getFullYear();
    if (!holidayCache[y]) {
      var set = {};
      ['1-1', '1-6', '5-1', '5-3', '8-15', '11-1', '11-11', '12-24', '12-25', '12-26'].forEach(function (s) { set[s] = 1; });
      var e = easter(y), em = new Date(e); em.setDate(e.getDate() + 1); var cc = new Date(e); cc.setDate(e.getDate() + 60);
      [em, cc].forEach(function (x) { set[(x.getMonth() + 1) + '-' + x.getDate()] = 1; });
      holidayCache[y] = set;
    }
    return !!holidayCache[y][(dt.getMonth() + 1) + '-' + dt.getDate()];
  }
  function isWork(dt) { var w = dt.getDay(); return w !== 0 && w !== 6 && !isHoliday(dt); }
  function addWork(from, n) { var d = new Date(from.getFullYear(), from.getMonth(), from.getDate()); var c = 0; while (c < n) { d.setDate(d.getDate() + 1); if (isWork(d)) c++; } return d; }
  function fmt(d, withDay) { return d.toLocaleDateString(LOCALE, withDay ? { weekday: 'short', day: 'numeric', month: 'long' } : { day: 'numeric', month: 'long' }); }

  function initDelivery(el) {
    if (el.__nvpInit) return; el.__nvpInit = true;
    var now = new Date();
    var min = Number(el.getAttribute('data-min')) || 7, max = Number(el.getAttribute('data-max')) || 12;
    var a = addWork(now, min), b = addWork(now, max);
    el.querySelectorAll('[data-from]').forEach(function (x) { x.textContent = fmt(a, true); });
    el.querySelectorAll('[data-to]').forEach(function (x) { x.textContent = fmt(b, true); });

    var xm = el.querySelector('[data-xmas]');
    if (xm) {
      var y = now.getFullYear();
      var by = Number(el.getAttribute('data-xmas-by')) || 23;
      var target = new Date(y, 11, by);
      var showFrom = new Date(y, (Number(el.getAttribute('data-xmas-from')) || 10) - 1, 1);
      if (now < showFrom || now > new Date(y, 11, 24, 23, 59)) { xm.hidden = true; }
      else {
        var dl = new Date(y, 11, by); // ostatni dzień zamówienia, przy którym najdłuższa dostawa mieści się w terminie
        while (addWork(dl, max) > target) dl.setDate(dl.getDate() - 1);
        var ok = now <= new Date(dl.getFullYear(), dl.getMonth(), dl.getDate(), 23, 59);
        var tpl = ok ? el.getAttribute('data-xmas-ok') : el.getAttribute('data-xmas-late');
        if (!tpl) { xm.hidden = true; }
        else {
          xm.querySelector('[data-xmas-text]').innerHTML = tpl.replace('[data]', '<strong>' + fmt(dl, false) + '</strong>');
          xm.classList.toggle('nvp-delivery__xmas--late', !ok);
          xm.hidden = false;
        }
      }
    }
    el.hidden = false;
  }

  /* ---------- MINI-OPINIE ---------- */
  function initMini(el) {
    if (el.__nvpInit) return; el.__nvpInit = true;
    var items = el.querySelectorAll('.nvp-mrev__item'), dots = el.querySelectorAll('.nvp-mrev__dots button');
    if (items.length < 2) return;
    var i = 0, timer;
    function show(n) { i = n; items.forEach(function (x, k) { x.classList.toggle('is-on', k === n); }); dots.forEach(function (d, k) { d.setAttribute('aria-current', k === n ? 'true' : 'false'); }); }
    function play() { if (el.getAttribute('data-auto') !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; clearInterval(timer); timer = setInterval(function () { if (document.hidden) return; show((i + 1) % items.length); }, 6000); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); play(); }); });
    el.addEventListener('mouseenter', function () { clearInterval(timer); });
    el.addEventListener('mouseleave', play);
    play();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.nvp-bundles').forEach(initBundles);
    (root || document).querySelectorAll('.nvp-delivery').forEach(initDelivery);
    (root || document).querySelectorAll('.nvp-mrev').forEach(initMini);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; initAll(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  setInterval(watchVariants, 400);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
